import { deleteFeildValue, editFeildValue, createFeildValue } from "../../api/fieldValue/modal.js";
import { Delete } from "@mui/icons-material";
import { Box, Button, CircularProgress, IconButton, Switch } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Dropdown, Modal, TextInput, UploadImage } from "../../../../shared/ui/common/index.js";

import Confirm from "../../../../shared/ui/modals/Confirm.jsx";


import { logout } from "../../../../shared/state/slices/user.js";
const FeildValueModal = ({
  open,
  close,
  data = {},
  forEdit,
  setAllRows,
  allRows,
  allFeilds,
}) => {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.user);
  const { id } = useParams();

  const [selectedProductImage, setselectedProductImage] = useState();
  const { userPermissions } = useSelector((state) => state.relationals);
  const [catSearchWord, setCatSearchWord] = useState("");
  const [category, setCategory] = useState("");
  const [loading, setLoading] = useState(false);
  const [prevData, setPrevData] = useState({ isDefault: false });
  const [openDelete, setOpenDelete] = useState(false);
  const [showingCats, setShowingCats] = useState([]);
  useEffect(() => {
    var temp = [];
    allFeilds.map((item) => {
      temp.push({
        ...item,
        title: `${item.title} ${item.description && item.description !== "undefined" ? item.description : ""}`,
      });
    });
    setShowingCats(temp);
  }, [allFeilds]);

  // set data
  useEffect(() => {
    if (forEdit) {
      setPrevData({
        ...data,
      });
    } else {
      resetData();
    }
  }, [allRows, data, forEdit, allFeilds]);
  const resetData = () => {
    setPrevData(data);
  };
  const deleteCategory = () => {
    if (data) {
      setLoading(true);
      deleteFeildValue(data, token)
        .then((res) => {
          setLoading(false);
          setOpenDelete(false);
          var temp = [...allRows];
          var newData = temp.filter((item) => item.id !== data.id);
          setAllRows(newData);
          close();
          toast.success("با موفقیت حذف شد");
        })
        .catch((err) => {
          setLoading(false);
          toast.error(err.response?.data?.message);
          setOpenDelete(false);
          if (err.response.status === 401) {
            dispatch(logout());
          }
        });
    }
  };
  const editItem = () => {
    var temp = [...allRows];
    /*     var data = {
      ...prevData,
      fieldId: id,
      childField: prevData?.childField?.id || null,
    }; */
    const formData = new FormData();
    formData.append("title", prevData?.title);
    formData.append("value", prevData?.value);

    if (prevData?.description)
      formData.append("description", prevData?.description);
    if (prevData?.avatar) formData.append("files", prevData?.avatar);
    if (selectedProductImage)
      formData.append("fromGallery", selectedProductImage);
    formData.append("fieldId", id);
    if (prevData?.childField)
      formData.append("childField", prevData?.childField || null);
    formData.append("isDefault", prevData?.isDefault ? true : false);
    if (forEdit) {
      formData.append("id", prevData?.id);
    }

    if (prevData?.title) {
      setLoading(true);
      if (forEdit) {
        editFeildValue(formData, token)
          .then((res) => {
            setLoading(false);
            toast.success("با موفقیت ویرایش شد");
            var index = temp.findIndex((item) => item.id === data.id);
            temp[index] = res.data.data;
            setAllRows(temp);
            close();
            resetData();
          })
          .catch((err) => {
            setLoading(false);
            toast.error(err.response?.data?.message);

            if (err.response.status === 401) {
              dispatch(logout());
            }
          });
      } else {
        createFeildValue(formData, token)
          .then((res) => {
            temp.unshift(res.data.data);

            setAllRows(temp);
            setLoading(false);
            toast.success("با موفقیت اضافه شد");
            close();
            resetData();
          })
          .catch((err) => {
            setLoading(false);
            toast.error(err.response?.data?.message);

            if (err.response.status === 401) {
              dispatch(logout());
            }
          });
      }
    } else if (!prevData?.title) {
      toast.error("نام فیلد را وارد کنید");
    }
  };

  return (
    <Modal
      open={open}
      close={close}
      title={` ${forEdit ? "ویرایش" : "افزودن"}  مقادیر فیلد
    `}
    >
      <TextInput
        label="نام   "
        change={(e) => setPrevData({ ...prevData, title: e })}
        currentValue={prevData?.title}
      />{" "}
      <TextInput
        label="مقدار   "
        change={(e) => setPrevData({ ...prevData, value: e })}
        currentValue={prevData?.value}
      />
      <Dropdown
        /*         value={prevData?.childField}
        change={(e) => setPrevData({ ...prevData, childField: e })} */
        value={showingCats?.find((item) => item.id === prevData?.childField)}
        change={(e) => setPrevData({ ...prevData, childField: e?.id })}
        data={showingCats}
        title=" فرزند فیلد"
        emptyValue={true}
      />
      <TextInput
        label="شرح   "
        change={(e) => setPrevData({ ...prevData, description: e })}
        currentValue={prevData?.description}
      />
      <UploadImage
        file={prevData?.avatar}
        change={(e) => setPrevData({ ...prevData, avatar: e })}
        address={data.galleryId ? data.galleryId : false}
        selectedProductImage={selectedProductImage}
        setselectedProductImage={setselectedProductImage}
      />
      <div className="flex flex-wrap items-center gap-3">
        <span>انتخاب پیش فرض : </span>
        <Switch
          checked={Boolean(prevData?.isDefault)}
          onChange={(e) =>
            setPrevData({ ...prevData, isDefault: !prevData?.isDefault })
          }
        />
      </div>
      <Box sx={{ display: "flex" }}>
        {forEdit && (
          <IconButton onClick={() => setOpenDelete(true)}>
            <Delete color="error" />
          </IconButton>
        )}
        <div style={{ flexGrow: 1 }} />
        <Button
          variant="contained"
          color="primary"
          onClick={editItem}
          disabled={loading}
        >
          {loading ? <CircularProgress /> : <>ثبت اطلاعات</>}
        </Button>
      </Box>
      <Confirm
        message="آیا از حذف این دسته بندی اطمینان دارید؟"
        close={() => setOpenDelete(false)}
        submit={deleteCategory}
        open={openDelete}
      />
    </Modal>
  );
};

export default FeildValueModal;
